<template>
  <table class="product-table uk-table uk-table-divider uk-table-justify">
    <tbody>
      <tr v-for="product in products">
        <td class="product-table__thumbnail-cell">
          <router-link
            v-if="product.teaserImage"
            :to="{ name: 'product', params: { id: product.id } }"
          >
            <img
              :src="product.teaserImage.thumbImageUrl"
              :alt="product.name"
            >
          </router-link>
          <text-placeholder v-else />
        </td>
        <td>
          <router-link
            :to="{ name: 'product', params: { id: product.id } }"
          >
            <span v-if="useVariantNames">
              {{product.variantName || product.name}}
            </span>
            <span v-else>
              {{product.name}}
            </span>
          </router-link>
          <div class="uk-text-muted">
            {{product.articleNumber}}
          </div>
        </td>
        <td>
          <data-grid-actions
            :edit-route="{ name: 'edit-product', params: { id: product.id }}"
            :removable="false"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import DataGridActions from '@/components/DataGridActions';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'product-table',
  components: {
    DataGridActions,
    TextPlaceholder,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    useVariantNames: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.product-table__thumbnail-cell {
  width: 44px;
}
</style>



// WEBPACK FOOTER //
// ProductTable.vue?a98df1b4